import type { AllowedImageMime } from "@/lib/types/file";

export const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20MB
export const ALLOWED_EXTENSIONS = "jpg, jpeg, png, heic, heif";

export const ALLOWED_MIME: AllowedImageMime[] = [
  "image/jpeg",
  "image/png",
  "image/heic",
  "image/heif",
] as const;
